import { t } from "@lingui/macro";
import { motion } from "framer-motion";

export const IframeLoading = () => {
  return (
    <div className="absolute inset-0 z-10 flex items-start justify-center bg-white pt-32 dark:text-gray-800">
      <div className="text-center">
        <div
          className="border-muted-foreground inline-block h-8 w-8 animate-spin rounded-full border-4 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        >
          <span className="!absolute !top-30 !-m-px !h-px !w-px !overflow-hidden !border-0 !p-0 !whitespace-nowrap ![clip:rect(0,0,0,0)]">
            Loading...
          </span>
        </div>
        <p className="text-muted-foreground text-md mt-3">{t`Loading resume...`}</p>
      </div>
    </div>
  );
};

export const PageLoading = () => {
  return (
    <div className="flex items-start justify-center">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center">
        <div
          className="border-primary inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        >
          <span className="!absolute top-10 !-m-px !h-px !w-px !overflow-hidden !border-0 !p-0 !whitespace-nowrap ![clip:rect(0,0,0,0)]">
            Loading...
          </span>
        </div>
        <p className="text-muted-foreground mt-3 text-sm">{t`Preparing comparison...`}</p>
      </motion.div>
    </div>
  );
};
